import {useState} from 'react';
import {setDrag} from '../service/createForm.slice';
import {useDispatch, useSelector} from 'react-redux';

export const useDragAndDrop = () => {
  const dispatch = useDispatch();
  const [draggedItem, setDraggedItem] = useState(null);

  const fields = useSelector(
    state => state.rootReducer.createFormSlice.data.fields,
  );

  const handleDragStart = (e, id) => {
    // e.target?.parentElement?.parentElement.dataTransfer.setData("id", id);
    setDraggedItem(id);
  };

  const handleDragOver = (e, id) => {
    e.preventDefault();
    const draggedOverItem = fields.find(field => field.id === id);
    if (draggedItem === draggedOverItem) {
      return;
    }
    let items = fields.filter(field => field.id !== draggedItem);
    let index = fields.indexOf(draggedOverItem);
    items.splice(
      index,
      0,
      fields.find(field => field.id === draggedItem),
    );
    dispatch(setDrag(items));
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
  };

  return {
    handleDragEnd,
    handleDragOver,
    handleDragStart,
  };
};
